var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListQrIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.5H18.5V1.5H17V8.45L14.675 7.025L12.35 8.45V1.5H4.5V15.5ZM4.5 17C4.1 17 3.75 16.85 3.45 16.55C3.15 16.25 3 15.9 3 15.5V1.5C3 1.1 3.15 0.75 3.45 0.45C3.75 0.15 4.1 0 4.5 0H18.5C18.9 0 19.25 0.15 19.55 0.45C19.85 0.75 20 1.1 20 1.5V15.5C20 15.9 19.85 16.25 19.55 16.55C19.25 16.85 18.9 17 18.5 17H4.5ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3H1.5V18.5H17V20H1.5ZM12.35 1.5H17H12.35ZM4.5 1.5H18.5H4.5Z",
    fill: "#AF4448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListQrIcon);
export default __webpack_public_path__ + "static/media/ListQr_icon.f9a314e8c91be36fc246776d14674a1d.svg";
export { ForwardRef as ReactComponent };